import {Component} from '@angular/core';
import {FieldWrapper} from '@ngx-formly/core';

@Component({
  selector: 'app-formly-category-tree-wrapper',
  standalone: true,
  template: `
    <label for="categories" class="form-field required standard">Categories</label>
    <div class="category-tree-wrapper">
      <ng-container #fieldComponent></ng-container>
    </div>
  `,
})
export class CategoryTreeWrapper extends FieldWrapper {}
